import { ErrorCard } from '../error-card';

interface Props {
  buttonLink?: string;
  buttonText?: string;
}

export const NotFound = ({ buttonLink = '/', buttonText = 'Home' }: Props) => (
  <ErrorCard
    buttonLink={buttonLink || '/'}
    buttonText={buttonText || 'Home'}
    guideline="The page you are trying to access does not exist."
    title="Page Not Found"
  />
);
